export const PeriodSurveysActionTypes = {
  API_RESPONSE_SUCCESS: '@@period-survey/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@period-survey/API_RESPONSE_ERROR',

  GET_PERIOD_SURVEY: '@@period-survey/GET_PERIOD_SURVEY',
  LIST_PERIOD_SURVEYS: '@@period-survey/LIST_PERIOD_SURVEYS',
  ADD_PERIOD_SURVEY: '@@period-survey/ADD_PERIOD_SURVEY',
  UPDATE_PERIOD_SURVEY: '@@period-survey/UPDATE_PERIOD_SURVEY',
  DELETE_PERIOD_SURVEY: '@@period-survey/DELETE_PERIOD_SURVEY',

  RESET: '@@period-survey/RESET'
}
